import { browserCrypto, nodeCrypto, Random as RandomJs } from 'random-js';

const VALUES: string[] = [];
export const Random = new RandomJs((typeof global !== 'undefined' ? nodeCrypto : null) || browserCrypto);

export const _randomStringFactory = (len = 6, prefix = '', suffix = ''): string =>
    `${prefix || ''}${Random.string(len)}${suffix || ''}`;

/**
 * Get uniq random string
 * @param args
 * @returns {*}
 */
_randomStringFactory.uniq = (...args) => {
    const hash: string = _randomStringFactory(...args);
    const found = VALUES.includes(hash);

    if (found) {
        VALUES.push(hash);
    }

    return found ? randomString.uniq(...args) : hash;
};

export const randomString = _randomStringFactory;

/**
 * Pick a random element from a given list
 * @param list
 * @returns {*}
 */
export const randomList = (list: []) => list[Math.floor(Math.random() * list.length)];

const CHAR_MAP = 'qwertyuioplkjhgfdsazxcvbnmPOIUYTREWQASDFGHJKLMNBVCXZ123456789-_';

/**
 *
 * @param len
 * @returns {string}
 */
export const randomPlainString = (len = 4): string => {
    return new Array(len)
        .fill('')
        .map(() => CHAR_MAP[Math.floor(Math.random() * CHAR_MAP.length)])
        .join('');
};

/**
 * UUID Generator
 * @returns {string}
 */
export const uuid = (): string => Random.uuid4();
